import { Link, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, cn } from '@c2fo/liquidity';
import HomepageHeader from '@/enterprise/components/HomepageHeader';
import useEnableUnification from '@/enterprise/components/useEnableUnification';
import HomePageBanner from '@/enterprise/features/homepage/homePageBanner/HomePageBanner';
import LendingInlineAd from '@/enterprise/features/lendingConnections/LendingInlineAd';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import { LendingModalWithContext } from '../lendingConnections/modal/LendingModalContext';
import AddCustomerBanner from './AddCustomerBanner';
import UnificationUpdateBanner from './UnificationUpdateBanner';

const HomepageLayoutComponent = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <LendingModalWithContext>
      <UnificationUpdateBanner />
      <HomepageHeader title={t('core.markets')} />
      <HomePageBanner />
      <div className="mb-6 mt-8 flex flex-col justify-between gap-4 md:flex-row md:items-center">
        <h3 className="m-0 text-2xl font-medium">{t('core.earlyPaymentMarkets')}</h3>
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
          <div className="text-sm font-bold text-text-secondary">{t('core.viewBy')}:</div>
          <div className="flex w-full flex-1 items-center">
            <Link className="w-1/2 md:w-fit" preventScrollReset to={asEnterpriseLink('customers')}>
              <Button
                className={cn('rounded-r-none', {
                  'bg-secondary-500 text-white hover:bg-secondary-700': pathname.includes('customers'),
                })}
                full
                variant="secondary"
              >
                {t('core.customers')}
              </Button>
            </Link>
            <Link className="ml-[-1px] w-1/2 md:w-fit" preventScrollReset to={asEnterpriseLink('markets')}>
              <Button
                className={cn('rounded-l-none', {
                  'bg-secondary-500 text-white hover:bg-secondary-700': pathname.includes('markets'),
                })}
                full
                variant="secondary"
              >
                {t('taker.dictionary.marketType')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <LendingInlineAd mode="homepage" />
      <Outlet />
      <AddCustomerBanner />
    </LendingModalWithContext>
  );
};

const HomepageLayout = () => {
  const enableUnification = useEnableUnification();

  if (enableUnification) {
    return <NavigateWithRedirect to={asEnterpriseLink('homepage')} />;
  }

  return <HomepageLayoutComponent />;
};

export default HomepageLayout;
